@let cp  = content();
@if (cp) {
  <div class="track-info">
    <div class="played-at-time">
      @if (startedAt()) {
        {{ startedAtFormatted() }}
      }
    </div>
    <div class="metadata-wrapper">
      <div class="text-lg font-bold">{{ trackName() }}</div>
      @if (cp.contentType !== 'MicBreak') {
        @if (cp.performerName) {
          <div class="md:mt-1">{{ cp.performerName }}</div>
        }
        <div class="text-sm">{{ cp.releaseName }}</div>
        <div class="hidden md:block text-sm">
          {{trackLabel()}}
        </div>
      }
    </div>
  </div>
}
